import React from 'react';
import { HashRouter, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import DiscordRedirect from './pages/DiscordRedirect';
import FAQsPage from './pages/FAQsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import NotFoundPage from './pages/NotFoundPage';
// Documentation pages
import DocsOverviewPage from './pages/docs/DocsOverviewPage';
import DocsCodebaseOverviewPage from './pages/docs/DocsCodebaseOverviewPage';
import DocsModuleDocumentationPage from './pages/docs/DocsModuleDocumentationPage';
import DocsApplicationUsagePage from './pages/docs/DocsApplicationUsagePage';
import DocsIntegrationGuidesPage from './pages/docs/DocsIntegrationGuidesPage';
import DocsTechnicalTopicsPage from './pages/docs/DocsTechnicalTopicsPage';
import DocsModuleDevelopmentPage from './pages/docs/DocsModuleDevelopmentPage';
import DocsRemoteLinkSystemPage from './pages/docs/DocsRemoteLinkSystemPage';
import DocsGameModulesPage from './pages/docs/DocsGameModulesPage';
import DocsCustomServersPage from './pages/docs/DocsCustomServersPage';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import CustomCursor from './components/CustomCursor';

const NonDocsContent: React.FC = () => {
  return (
    <LanguageProvider>
      <div className="app">
        <ScrollToTop />
        <CustomCursor />
        <Navbar />
        <main className="main">
          <Routes>
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/discord" element={<DiscordRedirect />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-logo">
                <div className="moon-logo"></div>
                <span>Project Lumina</span>
              </div>
              <div className="footer-links">
                <a href="https://github.com/TheProjectLumina/LuminaClient" className="social-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12C2 16.418 4.865 20.166 8.839 21.489C9.339 21.581 9.5 21.277 9.5 21.012C9.5 20.775 9.492 20.063 9.489 19.192C6.726 19.826 6.139 17.959 6.139 17.959C5.685 16.811 5.028 16.508 5.028 16.508C4.128 15.883 5.095 15.895 5.095 15.895C6.092 15.965 6.624 16.928 6.624 16.928C7.521 18.457 8.97 18.007 9.52 17.752C9.611 17.099 9.87 16.649 10.153 16.419C7.93 16.187 5.596 15.332 5.596 11.551C5.596 10.399 6.007 9.456 6.644 8.718C6.542 8.465 6.178 7.501 6.744 6.131C6.744 6.131 7.586 5.863 9.478 7.151C10.295 6.929 11.15 6.819 12.002 6.814C12.852 6.819 13.707 6.929 14.526 7.151C16.416 5.863 17.256 6.131 17.256 6.131C17.824 7.501 17.459 8.465 17.357 8.718C17.996 9.456 18.403 10.399 18.403 11.551C18.403 15.343 16.065 16.184 13.834 16.412C14.189 16.694 14.5 17.254 14.5 18.102C14.5 19.31 14.488 20.686 14.488 21.012C14.488 21.279 14.648 21.586 15.155 21.486C19.137 20.161 22 16.415 22 12C22 6.477 17.523 2 12 2Z" fill="currentColor"/>
                  </svg>
                  <span>GitHub</span>
                </a>
                <Link to="/discord" className="social-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.952 5.672C19.211 5.342 18.427 5.103 17.619 4.973C17.596 4.968 17.573 4.978 17.561 4.998C17.448 5.195 17.322 5.454 17.234 5.66C16.36 5.54 15.491 5.54 14.64 5.66C14.552 5.454 14.423 5.195 14.309 4.998C14.297 4.978 14.274 4.968 14.251 4.973C13.444 5.103 12.659 5.342 11.918 5.672C11.908 5.676 11.899 5.683 11.893 5.692C9.466 9.35 8.818 12.92 9.142 16.446C9.144 16.461 9.152 16.476 9.164 16.484C10.18 17.216 11.156 17.678 12.116 17.992C12.139 17.999 12.164 17.991 12.18 17.972C12.466 17.594 12.723 17.195 12.946 16.777C12.958 16.753 12.946 16.725 12.922 16.715C12.556 16.578 12.209 16.414 11.875 16.226C11.848 16.211 11.846 16.174 11.869 16.156C11.937 16.106 12.004 16.054 12.068 16.001C12.086 15.986 12.11 15.983 12.13 15.992C14.942 17.246 17.995 17.246 20.773 15.992C20.793 15.983 20.817 15.986 20.835 16.001C20.9 16.054 20.967 16.106 21.035 16.156C21.059 16.174 21.057 16.211 21.03 16.226C20.696 16.418 20.348 16.578 19.983 16.714C19.958 16.724 19.947 16.753 19.958 16.777C20.185 17.194 20.442 17.593 20.724 17.971C20.738 17.991 20.764 17.999 20.787 17.992C21.75 17.678 22.727 17.216 23.742 16.484C23.755 16.476 23.762 16.462 23.764 16.446C24.142 12.386 23.135 8.842 20.961 5.693C20.956 5.683 20.947 5.676 20.936 5.672H19.952Z" fill="currentColor"/>
                  </svg>
                  <span>Discord</span>
                </Link>
                <Link to="/docs/overview" className="social-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Documentation</span>
                </Link>
                <Link to="/privacy-policy" className="social-link">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Privacy Policy</span>
                </Link>
              </div>
            </div>
            <div className="copyright">
              &copy; {new Date().getFullYear()} Project Lumina. All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </LanguageProvider>
  );
};

const DocsContent: React.FC = () => {
  return (
    <div className="app">
      <ScrollToTop />
      <CustomCursor />
      <main className="main docs-main-content">
        <Routes>
          <Route path="/docs" element={<Navigate to="/docs/overview" replace />} />
          <Route path="/docs/overview" element={<LanguageProvider><DocsOverviewPage /></LanguageProvider>} />
          <Route path="/docs/codebase-overview" element={<LanguageProvider><DocsCodebaseOverviewPage /></LanguageProvider>} />
          <Route path="/docs/module-documentation" element={<LanguageProvider><DocsModuleDocumentationPage /></LanguageProvider>} />
          <Route path="/docs/module-development" element={<LanguageProvider><DocsModuleDevelopmentPage /></LanguageProvider>} />
          <Route path="/docs/remotelink-system" element={<LanguageProvider><DocsRemoteLinkSystemPage /></LanguageProvider>} />
          <Route path="/docs/game-modules" element={<LanguageProvider><DocsGameModulesPage /></LanguageProvider>} />
          <Route path="/docs/custom-servers" element={<LanguageProvider><DocsCustomServersPage /></LanguageProvider>} />
          <Route path="/docs/application-usage" element={<LanguageProvider><DocsApplicationUsagePage /></LanguageProvider>} />
          <Route path="/docs/integration-guides" element={<LanguageProvider><DocsIntegrationGuidesPage /></LanguageProvider>} />
          <Route path="/docs/technical-topics" element={<LanguageProvider><DocsTechnicalTopicsPage /></LanguageProvider>} />
        </Routes>
      </main>
    </div>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();
  const isDocsPage = location.pathname.startsWith('/docs');

  if (isDocsPage) {
    return <DocsContent />;
  }

  return <NonDocsContent />;
};


function App() {
  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}

export default App;